import { QueueListIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';

type AttributionsIconButtonProps = {
  to: string;
  label?: string;
  className?: string;
};

export function AttributionsIconButton({
  to,
  label = 'Atribuições do cargo',
  className = '',
}: AttributionsIconButtonProps) {
  return (
    <Link
      to={to}
      title={label}
      aria-label={label}
      className={`inline-flex items-center justify-center rounded-md p-1.5 text-secondary-500 transition-colors hover:bg-primary-50 hover:text-primary-600 ${className}`}
    >
      <QueueListIcon className="h-5 w-5" />
    </Link>
  );
}
